<div class="activity-information">
	<div class="info-card">
		<div class="wrapper">
			<section
				class="content-grid"
				[ngClass]="{'view-from-activity-overview': viewFrom === viewFromEnum.ACTIVITY_OVERVIEW}">
				@if (shouldShowActivityPicture()) {
					<button
						type="button"
						data-cy="activity-type-name"
						class="btn-none activity-type-btn"
						(click)="showActivityPicture()">
						{{ getActivityTypeName() }}
					</button>
				} @else {
					<span class="activity-type-text">
						{{ getActivityTypeName() }}
					</span>
				}

				@if (activity.isViewable('rubric_template_id') && isRubricEnabled()) {
					<button
						type="button"
						class="btn-none preview-rubric"
						(click)="previewRubric()"
						translate="activity-view_setting-indicator-preview-rubric">
					</button>
				}

				@if ((hasMarkerSet$ | async)) {
					<button
						type="button"
						class="btn-none preview-marker-set"
						(click)="previewMarkerSet()"
						translate="activity-view_setting-indicator-preview-marker-set">
					</button>
				}

				@if (shouldSeePreviewAiMarkers()) {
					<button
						type="button"
						class="btn-none preview-ai-markers"
						(click)="previewAiMarkers()"
						translate="activity-view_setting-indicator-preview-ai-markers">
					</button>
				}

				@if (!hideNumOfAttempts) {
					<span
						class="num-of-attempts"
						tabindex="0"
						translate="{{activity.isViewable('has_single_recording_attempt') && activity.has_single_recording_attempt ? 'activity-info_single-attempt' : 'activity-info_unlimited-attempts'}}">
					</span>
				}

				@if (!hideTimeLimit && activity.isViewable('time_limit') && activity.time_limit != null) {
					<span
						class="time-limit"
						tabindex="0"
						translate="{{ 'activity-view_time-limit-description' | translate: { value: activity.time_limit } }}">
					</span>
				}

				@if (!hidePoints && activity.total_score) {
					<span
						class="activity-points"
						data-cy="total-points"
						tabindex="0"
						[translateParams]="{ points: activity.total_score }"
						translate="activity-view_points">
					</span>
				}

				@if (activity.due_at !== null) {
					<span tabindex="0" class="activity-due-date">
						{{ 'activity-overview-due_date' | translate: {dueDate: activity.due_at | date: 'mediumDate'} }}
					</span>
				}
			</section>
		</div>
	</div>

	@if (somethingToShow()) {
		<div class="information-panels">
			@if (hideRecordingInstructions) {
				<div class="info-card">
					<div class="wrapper">
						<h5 translate="activity-info_recording-instructions"></h5>
						<span translate="activity-info_section-stimulus-available"></span>
					</div>
				</div>
			}

			@if (showInstructions('recording')) {
				<rich-instructions
					[instruction]="activity.recording_instructions">
				</rich-instructions>
			}

			@if (showInstructions('feedback')) {
				<rich-instructions
					[instruction]="activity.feedback_instructions">
				</rich-instructions>
			}

			@if (showSourceMedia() && isOnDashboard) {
				<media-card
					class="source-media"
					[label]="'assignment-information-stimulus-title'"
					[media]="activity.source_media.media">
				</media-card>
			}

			@if (showAttachments()) {
				<div class="info-card card-attachments" >
					<div class="wrapper">
						<h5 translate="activity-info_activity-resources"></h5>
						@if (!hideSourceMedia) {
							@for (attachment of activity.attachments; track attachment.id) {
								<media-card
									class="attachment-media"
									[media]="attachment.media">
								</media-card>
							}
						} @else {
							<section translate="activity-info_section-resources-available"></section>
						}
					</div>
				</div>
			}
		</div>
	} @else if (isOnDashboard) {
		<div class="no-information" translate="assignment-information-no-instructions"></div>
	}
</div>
